import React from 'react';
import Css from './ProductCard.module.scss';
import { compareAsc, format } from 'date-fns'




const ProductCard = ({ client }) => {
  return (
    <div className={Css.cards_item}>
      <div className={Css.card}>
        <div className={Css.card_image_container}>
          <div className={Css.card_image}>
            <img src={client?.logo || client?.thumbnail} alt={client.name} />
          </div>
          <div className={Css.live}>

            {/* <p>From : <strong>{format(new Date(client.start_date), 'Pp')}</strong></p>
            <p>To :  <strong>{format(new Date(client.end_date), 'Pp')}</strong></p> */}
          </div>
          <h2 className={Css.card_title}>{client.name}</h2>
        </div>
        <div className={Css.card_content}>
          <div className={Css.card_text}>
            <p>{client.description}</p>
          </div>
          {/* <div className={Css.date}>
            <p>Start Date : <strong>{format(new Date(client.start_date), 'Pp')}</strong></p>
            <p>End Date :  <strong>{format(new Date(client.end_date), 'Pp')}</strong></p>
          </div> */}

          <div className={Css.visit_link}>
            <a href={client?.website} target="_blank" className={Css.visit} rel="noreferrer">Visit the Fair</a>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ProductCard;